import { styled as e } from "@mui/material";
const t = e("div")(({ theme: e2 }) => ({ display: "flex", justifyContent: "center", alignItems: "center", width: "48px", height: "48px", borderRadius: "50%", background: e2.palette.primary[50] }));
export {
  t as IconBox
};
//# sourceMappingURL=styled.js.map
